module.exports = __webpack_public_path__ + "img/bread-easypay-usability.ee78bf0d.png";